import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-mantenimiento',
  standalone: false,
  templateUrl: './mantenimiento.component.html',
  styleUrl: './mantenimiento.component.css',
})
export class MantenimientoComponent implements OnInit {
  factura: any;
  searchControl = new FormControl('');
  filteredItems: any[] = [];
  sortedItems: any[] = [];

  currentPage = 1;
  itemsPerPage = 10;
  sortColumn: string = '';
  sortAsc: boolean = true;

  ngOnInit(): void {
    this.factura = {
      factura_nro: 'FC-001245',
      fecha_emision: '2025-06-27',
      proveedor: {
        ruc: '0999999999001',
        nombre: 'Proveedor Eléctrico Loja S.A.',
        lugar: 'Loja',
      },
      items: [
        {
          producto: 'Cable THW 2.5mm',
          cantidad: 100,
          codigo_imperium: 'IMP-00235',
          codigo_barra: '7861122334455',
          valor_unitario: 0.85,
          subtotal: 85.0,
        },
        {
          producto: 'Tubería PVC 1/2”',
          cantidad: 50,
          codigo_imperium: 'IMP-00451',
          codigo_barra: '7869988776655',
          valor_unitario: 1.2,
          subtotal: 60.0,
        },
      ],
    };

    this.filteredItems = this.factura.items;
    this.sortItems();

    this.searchControl.valueChanges
      .pipe(debounceTime(500))
      .subscribe((value: string | null) => this.filterItems(value ?? ''));
  }

  filterItems(search: string): void {
    if (!search) {
      this.filteredItems = this.factura.items;
    } else {
      const term = search.toLowerCase();

      this.filteredItems = this.factura.items.filter(
        (item: any) =>
          item.producto.toLowerCase().includes(search.toLowerCase()) ||
          item.codigo_imperium.toLowerCase().includes(search.toLowerCase())
      );
    }

    this.currentPage = 1;
    this.sortItems();
  }

  sortItems(column: string = this.sortColumn): void {
    if (column) {
      this.sortAsc = this.sortColumn === column ? !this.sortAsc : true;
      this.sortColumn = column;

      this.sortedItems = [...this.filteredItems].sort((a, b) => {
        const valA = a[column];
        const valB = b[column];
        return this.sortAsc ? (valA > valB ? 1 : -1) : valA < valB ? 1 : -1;
      });
    } else {
      this.sortedItems = [...this.filteredItems];
    }
  }

  pagedItems(): any[] {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    return this.sortedItems.slice(start, start + this.itemsPerPage);
  }

  totalPages(): number {
    return Math.ceil(this.sortedItems.length / this.itemsPerPage);
  }

  exportCSV(): void {
    const headers = [
      'producto',
      'codigo_imperium',
      'codigo_barra',
      'valor_unitario',
      'cantidad',
    ];
    const csvRows = [
      headers.join(','),
      ...this.sortedItems.map((item) =>
        headers.map((field) => item[field]).join(',')
      ),
    ];

    const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'factura.csv';
    link.click();
  }

  agregarAlInventario(item: any): void {
    console.log('Agregar:', item);
  }
}
